import React from 'react';
import { StyleSheet, Pressable } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import type { SharedValue } from 'react-native-reanimated';

const OVERLAY_COLOR = 'rgba(0, 0, 0, 0.22)';

interface AnimatedBackdropProps {
  opacity: SharedValue<number>;
  onPress?: () => void;
  enableBlur?: boolean;
}

export const AnimatedBackdrop: React.FC<AnimatedBackdropProps> = ({
  opacity,
  onPress,
  enableBlur = true,
}) => {
  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  const webBlurStyle = enableBlur
    ? ({ backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' } as any)
    : undefined;

  return (
    <Animated.View style={[StyleSheet.absoluteFill, animatedStyle]} pointerEvents="auto">
      <Pressable
        style={[styles.overlay, webBlurStyle]}
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel="Close modal"
      />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: OVERLAY_COLOR,
  },
});
